import script from "./PersonalizedAstrology.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalizedAstrology.vue?vue&type=script&setup=true&lang=js"

import "./PersonalizedAstrology.vue?vue&type=style&index=0&id=5762aef9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5762aef9"]])

export default __exports__